import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PolizzeFormComponent } from '../dialogs/form/form.component';
import { PolizzaViewComponent } from './polizza-view/polizza-view.component';

const routes: Routes = [

  {
    path: '', component: PolizzaViewComponent, //All routes are wrapped in this one. Essentially we need to first load the sidebar no matter what.
    children: [ //then depending on the route we load a child route to be displayed in the router outlet.
      { path: 'somme-assicurate', loadChildren: () => import('../somme-assicurate/somme-assicurate.module').then(m => m.SommeAssicurateModule) },
      { path: '', component: PolizzeFormComponent },
    ]
  },

]
  ;

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PolizzaViewRoutingModule { }
